import React, { useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import { Menu } from "primereact/menu";
import { useSelector } from "react-redux";

import { downloadFileHandler } from "~/utils/fileUtils";
import CustomeButton from "~/components/Button";
import FileIcon from "~/components/file-type-icon";
import Categories from "~/components/Processes/conversations/utils/categories.json";
import AdminOnly from "~/components/AdminOnly";
import fileUploadLogo from "../../../assets/attachment-paperclip.svg";
import DocumentDescription from "~/components/document-description";
import { useParams } from "react-router-dom";

const ShareholderAttachmentTable = ({
  loading,
  isDataAvailable,
  files,
  setOpenDialog,
  rows,
  onPageChange,
  first,
  handleAttachmentDelete,
}) => {
  const skeletonRows = [...Array(5)];
  const menuRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const { id: userId, role } = useSelector((state) => state.login);
  const { id } = useParams();
  const handleMenuToggle = (e, rowData) => {
    setSelectedRow(rowData);
    menuRef.current.toggle(e);
  };
  const actionMenuItems = () => [
    // {
    //   label: "Download",
    //   icon: "pi pi-download",
    //   command: () => downloadFileHandler({
    //     blob_url: rowData?.blob_url,
    //     name: rowData?.name,
    //   })
    // },
    {
      label: "Delete",
      icon: "pi pi-trash",
      command: () => handleAttachmentDelete(selectedRow),
    },
  ];
  return (
    <div>
      {isDataAvailable ? (
        <DataTable
          value={loading ? skeletonRows : files}
          className="datatable-right-align"
          paginator={files?.length > 10}
          first={first}
          rows={rows}
          onPage={onPageChange}
          totalRecords={files?.length}
          rowsPerPageOptions={[10, 20, 30]}
          emptyMessage="No attachments found"
        >
          <Column
            header="Name"
            body={(field) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <div className="file__name">
                  <FileIcon
                    filetype={field?.file_type}
                    filename={field?.name}
                    downloadFile={() =>
                      downloadFileHandler({
                        blob_url: field?.blob_url,
                        name: field?.name,
                      })
                    }
                  />
                </div>
              )
            }
          />
          <Column
            header="Category"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                Categories.find((c) => c.code === data.category)?.name
              )
            }
          />
          <Column
            header="Subcategory"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                Categories.find(
                  (c) => c.code === data.category,
                )?.subCategory?.find?.((s) => s.code === data.subCategory)?.name
              )
            }
          />
          <Column
            className="user_action--col"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <>
                  <div className="flex align-items-center">
                    <div className="flex mr-3">
                      <DocumentDescription
                        data={data}
                        id={id}
                        type="SHAREHOLDERS"
                      />
                    </div>
                    <span
                      className="pi pi-download pencil-pointer"
                      onClick={() =>
                        downloadFileHandler({
                          blob_url: data?.blob_url,
                          name: data?.name,
                        })
                      }
                    ></span>

                    <div className="align-items-center justify-content-end  gap-0 ">
                      <Menu
                        model={actionMenuItems()}
                        popup
                        ref={menuRef}
                        id="action_menu"
                      />
                      {(role === "GXM_ADMIN" || data.created_by === userId) && (
                        <CustomeButton
                          icon="pi pi-ellipsis-v"
                          variant="no-outlined"
                          className="p-button-text p-button-rounded"
                          onClick={(e) => handleMenuToggle(e, data)}
                          aria-controls="action_menu"
                          aria-haspopup
                        />
                      )}
                    </div>
                  </div>
                </>
              )
            }
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <div className="no-documents-uploaded-section w-full">
            <img
              src={fileUploadLogo}
              alt="file-upload"
              className="file-upload-logo"
            />
            <p className="add-new-entity-heading mb-0">
              No Documents uploaded yet
            </p>
            <p className="drag-drop-text m-0">
              {
                "Upload supporting documents for this shareholder, such as ID or proof of address."
              }
            </p>
            <AdminOnly>
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setOpenDialog(true)}
              />
            </AdminOnly>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareholderAttachmentTable;
